import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className="panel">
      <h2>找不到頁面</h2>
      <p>您嘗試存取的頁面不存在。</p>
      <Link to="/">回到首頁</Link>
    </div>
  );
};

export default NotFoundPage;

